export default {"id":"360ae85c","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}